import Api from '@/services/api.js'

export default {
  getCompliances(payload) {
    return Api.post('compliance/', payload)
  },
  updateComplianceResource(complianceResource, id) {
    //var complianceResourceId = complianceResource.id;
    return Api.put(`compliance/${id}`, complianceResource);
  },

  uploadCompliance(file) {
    return Api.post('compliance/file', file)
  },
  downloadCompliance(key) {
    return Api.get(`compliance/${key}`)
  },
  uploadComplianceResource(data) {
    return Api.post('compliance/resource', data)
  },
  deleteComplianceResource(compliance) {
    return Api.delete(`compliance/${compliance}`);
  },
}

